export default function RedirectOnlyComponent() {
  // Renders nothing by design. Used as a HydrateFallback and for redirect-only routes.
  return null;
}
